import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <div className="contact-container">
      <h1 className="contact-header">Contactez-nous</h1>
      <form className="contact-form">
        <input
          type="text"
          placeholder="Votre nom"
          className="contact-input"
        />
        <input
          type="email"
          placeholder="Votre email"
          className="contact-input"
        />
        <textarea
          placeholder="Votre message"
          className="contact-input"
          rows="4"
        ></textarea>
        <button type="submit" className="contact-submit">
          Envoyer
        </button>
      </form>
    </div>
  );
}

export default Contact;
